import React, { useEffect, useRef } from "react";
import "./Job.css";
import Slider from "../../Components/Service Partners/Trusted";
import jobImg1 from "../../Images/jobImg1.jpg";
import jobImg2 from "../../Images/jobImg2.jpg";
import jobComImg1 from "../../Images/jobComImg1.jpg";
import jobComImg2 from "../../Images/jobComImg2.jpg";
import jobComImg3 from "../../Images/jobComImg3.jpg";

const Job = () => {
  const observerRef = useRef(null);

  useEffect(() => {
    // Create intersection observer for scroll animations
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-visible");
            entry.target.classList.remove("animate-hidden");
          } else {
            entry.target.classList.remove("animate-visible");
            entry.target.classList.add("animate-hidden");
          }
        });
      },
      { threshold: 0.2 }
    );

    // Observe all elements with animation classes
    const animatedElements = document.querySelectorAll(
      ".fade-in, .slide-up, .slide-left, .slide-right, .zoom-in, .stagger-item, .rotate-in, .bounce-in"
    );

    animatedElements.forEach((el) => {
      el.classList.add("animate-hidden");
      observerRef.current.observe(el);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="jobSection">
      <div className="jobHero">
        <img src={jobImg1} alt="jobImg1" />
        <div className="jobHeroCover">
          <div className="jobHeroText zoom-in">
            <h1>Explore Career Paths</h1>
            <p>
              Search jobs by category to uncover internships, entry-level roles,
              and industry-specific opportunities. Your next step starts here.
            </p>
            <button className="bounce-in">
              <a href="/jobSub">Explore Job</a>
            </button>
          </div>
        </div>
      </div>

      <div className="jobSection1">
        <div className="jobSection1Text slide-left">
          <h2>Explore Jobs by Category</h2>
          <p>
            Discover career opportunities tailored to your interests and
            expertise. Whether you're seeking roles in technology, design,
            business, healthcare, or education, our categorized listings make it
            easy to find the right fit. Navigate by industry, skill set, or job
            type to uncover internships, entry-level positions, and experienced
            roles—all curated to help you take the next step in your
            professional journey.
          </p>
        </div>
        <img src={jobImg2} alt="jobImg2" className="slide-right" />
      </div>

      <div className="jobCareer fade-in">
        <h2>Start Your Career Journey Today</h2>
        <p>
          Create your professional profile and explore verified job listings by
          category. Whether you're a student, fresher, or experienced candidate,
          Career Restorer helps you find the right opportunities across tech,
          design, business, and more. Build your future—one click at a time.
        </p>
        <button className="slide-up">
          <a href="/jobSub">Borwse Jobs</a>
        </button>
      </div>

      <div className="jobCareer2">
        {[
          { number: "8M", text: "Matches" },
          { number: "150K+", text: "Tech Jobs" },
          { number: "10M+", text: "Startup Ready Candidates" },
        ].map((stat, index) => (
          <h3
            key={index}
            className="bounce-in"
            style={{ transitionDelay: `${index * 0.2}s` }}
          >
            {stat.number}
            <br />
            <span>{stat.text}</span>
          </h3>
        ))}
      </div>

      {/* <Slider /> */}

      <div className="jobStartup">
        <h2 className="fade-in">Trending startups hiring now</h2>
        <div className="jobStartupBlock">
          {[
            {
              img: jobComImg1,
              name: "Beautiful.ai",
              employees: "51-200 employees",
              desc: "Be proud of what you present",
              tags: [
                "Responds within three weeks",
                "B2B",
                "B2C",
                "Growth Stage",
                "Top Investors",
              ],
            },
            {
              img: jobComImg2,
              name: "HeartStamp",
              employees: "11-50 employees",
              desc: "Funded stealth startup building a generative AI platform to revolutionize global creat",
              tags: [
                "Top 5% of responders",
                "Growing fast",
                "Responds within a few days",
              ],
            },
            {
              img: jobComImg3,
              name: "Ground Signal",
              employees: "11-50 employees",
              desc: "Sales optimization for the Alcohol industry",
              tags: [
                "Top 5% of responders",
                "Early Stage",
                "B2C",
                "Responds within a few days",
                "B2B",
              ],
            },
          ].map((company, index) => (
            <div
              key={index}
              className="jobStartupCard slide-up"
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <div className="jobStartupImg">
                <img src={company.img} alt={company.name} />
                <div className="jobStartupImg2">
                  <h3>{company.name}</h3>
                  <p>{company.employees}</p>
                </div>
              </div>
              <div className="jobStartupText">
                <p>{company.desc}</p>
                <div className="jobStartupText2">
                  {company.tags.map((tag, tagIndex) => (
                    <span key={tagIndex}>{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Job;
